import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { CONTRACTS } from '../contracts/addresses';
import { VAULT_ABI, ERC20_ABI } from '../contracts/abis';

function DepositForm({ signer, account, provider, onSuccess }) {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [balance, setBalance] = useState('0');

  useEffect(() => {
    loadBalance();
  }, [provider, account]);

  const loadBalance = async () => {
    if (!provider || !account) return;
    try {
      const usdc = new ethers.Contract(CONTRACTS.usdc, ERC20_ABI, provider);
      const bal = await usdc.balanceOf(account);
      setBalance(ethers.utils.formatUnits(bal, 6));
    } catch (error) {
      console.error('Error loading balance:', error);
    }
  };

  const setMaxAmount = () => {
    setAmount(balance);
  };

  const handleDeposit = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      setStatus('Enter amount');
      return;
    }

    if (parseFloat(amount) > parseFloat(balance)) {
      setStatus('Insufficient balance');
      return;
    }

    setLoading(true);
    setStatus('');

    try {
      const vault = new ethers.Contract(CONTRACTS.vault, VAULT_ABI, signer);
      const usdc = new ethers.Contract(CONTRACTS.usdc, ERC20_ABI, signer);
      
      const amountWei = ethers.utils.parseUnits(amount, 6);

      setStatus('Approving...');
      const allowance = await usdc.allowance(account, CONTRACTS.vault);
      
      if (allowance.lt(amountWei)) {
        const approveTx = await usdc.approve(CONTRACTS.vault, amountWei);
        await approveTx.wait();
      }

      setStatus('Depositing...');
      const tx = await vault.deposit(amountWei, account);
      await tx.wait();

      setStatus('Success!');
      setAmount('');
      await loadBalance();
      if (onSuccess) onSuccess();
      
      setTimeout(() => setStatus(''), 3000);
    } catch (error) {
      console.error('Deposit error:', error);
      if (error.code === 4001) {
        setStatus('Cancelled');
      } else {
        setStatus('Failed: ' + (error.reason || 'Unknown error'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <h3>Deposit</h3>
      
      <div className="input-group">
        <input
          type="number"
          placeholder="0.00"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          disabled={loading}
        />
        <button className="max-btn" onClick={setMaxAmount} disabled={loading}>
          MAX
        </button>
        <span className="suffix">USDC</span>
      </div>

      <div className="balance-text">
        Available: {parseFloat(balance).toFixed(2)} USDC
      </div>

      <button 
        className="submit-btn"
        onClick={handleDeposit}
        disabled={loading || !amount || parseFloat(amount) <= 0}
      >
        {loading ? 'Processing...' : 'Deposit'}
      </button>

      {status && (
        <div className={`status ${
          status === 'Success!' ? 'success' : 
          status.includes('Failed') ? 'error' : 
          'info'
        }`}>
          {status}
        </div>
      )}
    </div>
  );
}

export default DepositForm;